import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import styles from '@/modules/general-notes/styles.less';

const NoteDetails = ({ items = [], onToggle }) => {
  if (!items.length) return null;

  return (
    <div className={styles.noteDetail}>
      {items.map((item, index) => (
        <label className={styles.noteDetailRowLabel} key={`${item.label}-${index}`}>
          <Checkbox
            checked={!!item.done}
            className={styles.noteDetailCheckbox}
            size="small"
            sx={{
              padding: '2px',
            }}
            onChange={(event) =>
              onToggle && onToggle(item, index, event.target.checked)
            }
            disabled={!onToggle}
          />
          <span
            className={styles.noteDetailLabel}
          >
            {item.label}
          </span>
        </label>
      ))}
    </div>
  );
};

export default NoteDetails;
